import rem from '../tools/rem'

export default `
    max-width: ${rem('1000px')};
    padding: 0 ${rem('30px')};
    margin: 0 auto;
    width: 100%;
`
